import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
//import { SpecialityService } from 'src/app/_services/speciality.service';
import { NotificationService } from './../../_services/notification.service';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-addedit-notification-master',
  templateUrl: './addedit-notification-master.component.html',
  styleUrls: ['./addedit-notification-master.component.scss']
})
export class AddeditNotificationMasterComponent implements OnInit {

  notification: any =
  {
  utoken:localStorage.getItem("utoken"),
  usermasterid:localStorage.getItem("user_master_id"),
  nid: 0,
  notificationtitle: '',
  content:'',
  smscontent:'',
  appname:'',
  screenname:'',
  status: 'Active',
  smsstatus:'Active'
  };
  errorMessage: string;
  submitted = false;
addedit:any

productLoading:Boolean=false

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar:MatSnackBar,
    private notificationservice:NotificationService) 
  { 


  }


  ngOnInit() 
  {
    this.addedit='0'
    this.route.params.subscribe(
      params => {
      if(this.route.snapshot.params.nid)
      {
      this.notificationservice.geteditnotificationdata(this.route.snapshot.params.nid)
      .subscribe(
       data => {

console.log("data",data)

      
     this.notification.nid=data.Data[0].nid
      this.notification.notificationtitle=data.Data[0].notification_title
      this.notification.content=data.Data[0].content
       this.notification.status=data.Data[0].status
       this.notification.status=data.Data[0].status
       
       this.notification.appname=data.Data[0].app_type
       this.notification.screenname=data.Data[0].screen_name
       this.notification.smscontent=data.Data[0].sms_contents


       this.notification.smsstatus=data.Data[0].sms_status

       this.addedit=this.notification.nid
  //console.log("speciality",data)
    })
      }
      })
  

    }




  onSubmit() 
  {

    this.submitted = true;
    this.productLoading=true

console.log("this.notification.smscontent",this.notification.smscontent)


console.log("this.notification.content",this.notification.content)


if((this.notification.smscontent!='')||(this.notification.content!=''))
{
    this.notificationservice.createnotification(this.notification)
 .subscribe(
    data => {
    if(data.status_code==200)
    {
      this.productLoading=false
      
      this.snackbar.open(data.Metadata.Message, '', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-green']
      });
    this.router.navigate(['/notification']);
    }
    else
    {
      this.productLoading=false
 
      this.snackbar.open(data.Metadata.Message, '', {
  duration: 2000,
   verticalPosition:"top",
  extraClasses: ['bg-red']
}); 
}

})
}
else{

  this.snackbar.open("Please enter Notification Content OR Sms Content ", '', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
  });

}

}

}



// WEBPACK FOOTER //
// ./src/app/component/addedit-notification-master/addedit-notification-master.component.ts